import { Button, Tooltip } from 'antd';
import { getGetAttoPdfQueryKey } from 'client/api/backend/procedimenti/procedimenti';
import { appConfig } from 'client/core/appConfig';
import { joinPath } from 'client/core/network/joinPath';
import React, { useMemo } from 'react';

interface IProcedureDocumentActButtonProps {
  procedureId: string;
  documentId: string | undefined;
}

export function ProcedureDocumentActButton(
  props: IProcedureDocumentActButtonProps
) {
  const { procedureId, documentId: fileId } = props;

  const path = useMemo(
    () => getGetAttoPdfQueryKey(procedureId, fileId ?? '<undefined>')[0],
    [procedureId, fileId]
  );

  if (!fileId) {
    return (
      <Tooltip title={'Nessun documento caricato'}>
        <Button size="large" type="primary" disabled>
          Visualizza Atto
        </Button>
      </Tooltip>
    );
  }

  return (
    <a
      target="_blank"
      href={joinPath([appConfig.remotePath, appConfig.apiBackendPath, path])}
    >
      <Button size="large" type="primary">
        Visualizza Atto
      </Button>
    </a>
  );
}
